import { GraphQLError } from "graphql"

import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"

import { getEmployeeReference } from "../../shared/utils/getEmployeeReference"

export const mutationCancelDocument = {
  async cancelDocument(_parent, args, context, _info) {
    const { lang, cdn, orderNumber, values } = args
    const { user, sanityClient: client } = context

    if (!user?.allowDocumentMutation) {
      throw new GraphQLError("Document action is not allowed for this user", {
        extensions: {
          code: "NOT_ALLOWED",
        },
      })
    }

    const config = AppSettings.sanityConfigByLang(lang)
    client.config({ ...config, useCdn: cdn })

    const [arctiveDocument, createdBy] = await Promise.all([
      getDocumentFromArchive({ orderNumber }),
      getEmployeeReference({
        employeeNumber: user.employeeNumber,
        sanityClient: client,
      }),
    ])
    if (!arctiveDocument) {
      throw new GraphQLError("Document was not found", {
        extensions: {
          code: "NOT_FOUND",
        },
      })
    }

    if (
      !["AU", "BA", "NL", "BR", "RÜ"].includes(arctiveDocument.orderType) ||
      arctiveDocument.branchNumber !== values.branchId
    ) {
      throw new GraphQLError("Document can not be canceled!", {
        extensions: {
          code: "NOT_ALLOWED",
        },
      })
    }

    const doc = {
      _type: "documentCancel",
      customerNumber: arctiveDocument.customerNumber,
      orderNumber: arctiveDocument.orderNumber,
      branchId: values.branchId,
      reason: values.reason,
      modificationSource: "Sanity",
      createdAt: new Date().toISOString().split("T")[0],
      modifiedAt: new Date().toISOString().split("T")[0],
      createdBy,
      modifiedBy: createdBy,
    }

    const insertDocumentCancel = await client.create(doc)
    return { id: insertDocumentCancel?._id }
  },
}

/**
 * @param {{orderNumber: string}}
 * @returns {object}
 */
const getDocumentFromArchive = async ({ orderNumber }) => {
  const graphiQLQueryObject = [
    {
      method: "findOrder",
      variables: { orderNumber },
      fields: ["orderNumber", "customerNumber", "orderType", "branchNumber"],
    },
  ]

  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  const documentResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

  return documentResponse
}
